export { SlotStaticData } from './ui';
